import { Routes } from '@angular/router';

import { RoleManagementStore } from './services/role-management.store';
import { roleFormCanDeactivateGuard } from './guards/role-form-can-deactivate.guard';

export const ROLE_MANAGEMENT_ROUTES: Routes = [
  {
    path: 'user-role-management/roles',
    providers: [RoleManagementStore],
    loadComponent: () =>
      import('./pages/role-management-shell/role-management-shell').then(
        (m) => m.RoleManagementShell,
      ),
    children: [
      {
        path: 'new',
        canDeactivate: [roleFormCanDeactivateGuard],
        loadComponent: () => import('./pages/role-form/role-form').then((m) => m.RoleForm),
        data: {
          layout: {
            activeItem: 'User & Role Management',
            breadcrumb: 'User & Role Management > Create Role',
            title: 'Create Role',
            subtitle: 'Define which policies can be access by roles',
            showToolbar: false,
            backTo: '/user-role-management?section=roles',
          },
          mode: 'create',
        },
      },
      {
        path: ':roleId/edit',
        canDeactivate: [roleFormCanDeactivateGuard],
        loadComponent: () => import('./pages/role-form/role-form').then((m) => m.RoleForm),
        data: {
          layout: {
            activeItem: 'User & Role Management',
            breadcrumb: 'User & Role Management > Edit Role',
            title: 'Edit Role',
            subtitle: 'Define which policies can be access by roles',
            showToolbar: false,
            backTo: '/user-role-management?section=roles',
          },
          mode: 'edit',
        },
      },
      {
        path: ':roleId',
        loadComponent: () => import('./pages/role-detail/role-detail').then((m) => m.RoleDetail),
        data: {
          layout: {
            activeItem: 'User & Role Management',
            breadcrumb: 'User & Role Management > Role Details',
            title: 'Role Details',
            subtitle: 'View role details, assigned policies and access information',
            showToolbar: false,
            backTo: '/user-role-management?section=roles',
          },
        },
      },
    ],
  },
];
